export abstract class BaseRangeFixer implements Editor.Selection.Range.IEditorRangeVisitor {
  updated: boolean = false;
  abstract visitDoDOCRange(range: Editor.Selection.EditorRange): void;
  abstract visitJsonRange(range: Editor.Selection.JsonRange): void;
}
